import React, { useState } from "react";
import {
  ChevronDownIcon,
  ChevronUpIcon,
  DocumentIcon,
} from "../../../../helper/HwIcon";

function decodeHtml(html) {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}

export const HotelPolicies = ({details, isOwn}) => {
  let policyData = details?.guestPolicies;

  if (isOwn) {
    const guest = Array.isArray(policyData) ? policyData : [];
    const badgeCheckIn = guest.find((p) => p?.label === "Check-in")?.description || details?.checkInTime;
    const badgeCheckOut = guest.find((p) => p?.label === "Check-out")?.description || details?.checkOutTime;
    const rules = guest.filter((p) => !["Check-in", "Check-out"].includes(p?.label) && (p?.description ?? "").toString().trim());
    const other = (Array.isArray(details?.otherPolicies) ? details.otherPolicies : []).filter((p) => (p?.paragraphs || []).length);
    return (
      <div id="hotel_property_policies" className="hw-hotel--singleListSection">
        <h2 className="h4 mb-20">Property Policies</h2>
        <div className="hw-section--box">
          {(badgeCheckIn || badgeCheckOut) && (
            <div className="date-badge--show mb-20">
              {badgeCheckIn && <span className="hw-fontBold hw-gray-900">Check-In: {badgeCheckIn}</span>}
              {badgeCheckOut && <span className="hw-fontBold hw-gray-900">Check-Out: {badgeCheckOut}</span>}
            </div>
          )}
          {(details?.phone || details?.email) && (
            <>
              <div className="hw-fontBold hw-gray-900 mb-2">Contact Us</div>
              <ul className="arrow-ul mb-20">
                {details?.phone && <li>{details.phone}</li>}
                {details?.email && <li>{details.email}</li>}
              </ul>
            </>
          )}
          {details?.languages && details.languages.length > 0 && (
            <>
              <div className="hw-fontBold hw-gray-900 mb-2">Languages Spoken</div>
              <ul className="arrow-ul mb-20"><li>{details.languages.join(", ")}</li></ul>
            </>
          )}
          {rules.map((p, i) => (
            <React.Fragment key={`g-${i}`}>
              <div className="hw-fontBold hw-gray-900 mb-2">{p?.label}</div>
              <ul className="arrow-ul mb-20">
                <li dangerouslySetInnerHTML={{ __html: decodeHtml(p?.description ?? "") }} />
              </ul>
            </React.Fragment>
          ))}
          {other.map((p, i) => (
            <React.Fragment key={`o-${i}`}>
              <div className="hw-fontBold hw-gray-900 mb-2">{p?.title}</div>
              <ul className="arrow-ul mb-20">
                {(p?.paragraphs || []).map((para, j) => (
                  <li key={j} dangerouslySetInnerHTML={{ __html: decodeHtml(para ?? "") }} />
                ))}
              </ul>
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  }

  return (
    // let description = details?.description;
    <div id="hotel_property_policies" className="hw-hotel--singleListSection">
      <h2 className="h4 mb-20">Property Policies</h2>
      <div className="hw-section--box">
        <div className="date-badge--show mb-20">
          {
            policyData && policyData?.length > 0 ? (
              <><span className="hw-fontBold hw-gray-900">Check-In: {policyData?.find((policy) => policy?.label === 'Check-in')?.description}</span>
                <span className="hw-fontBold hw-gray-900">Check-Out: {policyData?.find((policy) => policy?.label === 'Check-out')?.description}</span></>
            ) : (
              <><span className="hw-fontBold hw-gray-900">Check-In: {details?.checkInTime}</span>
                <span className="hw-fontBold hw-gray-900">Check-Out: {details?.checkOutTime}</span></>
            )
          }
        </div>
        {
          (details?.phone||details?.email || details?.postalCode) && (
           <> <div className="hw-fontBold hw-gray-900 mb-2">
            Contact Us
          </div>
            <ul className="arrow-ul mb-20">
              {details?.phone && <li>{details?.phone}</li>}
              {details?.email && <li>{details?.email}</li>}
            </ul>
            </>
          )
        }
        {details?.languages && details.languages.length > 0 && (
          <>
            <div className="hw-fontBold hw-gray-900 mb-2">Languages Spoken</div>
            <ul className="arrow-ul mb-20">
              <li>{details.languages.join(", ")}</li>
            </ul>
          </>
        )}
        {policyData && policyData.length > 0 ? (
          <>
            <div className="hw-fontBold hw-gray-900 mb-2">Must Read Rules</div>
            <ul className="arrow-ul mb-20">
              {policyData
                .filter(policy =>
                  [
                    "Room Rates",
                    "Pets",
                    "Internet",
                    "Parking",
                    "Children Policy",
                  ].includes(policy?.label)
                )
                .map((policy, index) => (
                  // <li key={index}>{policy?.description}</li>
                  <li dangerouslySetInnerHTML={{ __html: decodeHtml(policy?.description ?? "") }} />
                ))}
            </ul>
            <div className="hw-fontBold hw-gray-900 mb-2">
              Child & Extra Bed Policy
            </div>

            <ul className="arrow-ul mb-20">
              {policyData
                .filter(policy =>
                  [
                    "Children & Extra Beds",
                    "Extra Beds Policy",
                    "Children Policy",
                  ].includes(policy?.label)
                )
                .map((policy, index) => (
                  // <li key={index}>{policy?.description}</li>
                  <li dangerouslySetInnerHTML={{ __html: decodeHtml(policy?.description ?? "") }} />
                ))}
            </ul>
          </>
        ) : null}
        {
          details?.policyInfo &&
          <>
            <div className="hw-fontBold hw-gray-900 mb-2">
              Policy Information
            </div>
            <ul className="arrow-ul mb-20">
              <li dangerouslySetInnerHTML={{ __html: decodeHtml(details?.policyInfo ?? "") }} />
            </ul></>
        }
        {
          details?.description && details?.description?.length > 0 ? <>
          {
            details?.description?.map((policy, index) => (
              <>
              <div className="hw-fontBold hw-gray-900 mb-2">
              {policy?.title}
            </div>
            <ul className="arrow-ul mb-20">
              {policy?.paragraphs?.
                map((paragraph, index) => (
                  // <li key={index}>{paragraph}</li>
                  <li dangerouslySetInnerHTML={{ __html: decodeHtml(paragraph ?? "") }} />
                ))}
            </ul>
              </>
            ))
          }
          </> : null}
          {
          details?.otherPolicies && details?.otherPolicies?.length > 0 ? <>
          {
            details?.otherPolicies?.map((policy, index) => (
              <>
              <div className="hw-fontBold hw-gray-900 mb-2">
              {policy?.title}
            </div>
            <ul className="arrow-ul mb-20">
              {policy?.paragraphs?.
                map((paragraph, index) => (
                  <li dangerouslySetInnerHTML={{ __html: decodeHtml(paragraph ?? "") }} />
                ))}
            </ul>
              </>
            ))
          }
          </> : null}
      </div>
    </div>
  );
};

export const HotelCancenlationPolicies = ({
  title,
  overideClassName,
  data,
}) => {
  return (
    <div id="hotel_refund_policy" className="hw-hotel--singleListSection">
      {/* {title ? (
        <h2 className="h4 mb-20">{title ?? "Cancellation & Refund Policy"}</h2>
      ) : (
        <h2 className="h4 mb-20">{"Cancellation & Refund Policy"}</h2>
      )} */}
      <div className={overideClassName ?? "hw-section--box"}>
        {data?.map((room, roomIndex) => (
          room?.cancellationPolicy?.map((policy, index) => (
            <div className="row  mb-02" key={index}>
              <div className="col-12">
                <div className="hw-text14 hw-fontWeight--500">
                  From <strong>{policy.fromDate}</strong> to <strong>{policy.toDate}</strong>,
                  a cancellation fee of <strong>AED {policy.amount}</strong> will apply.
                </div>
              </div>
            </div>
          ))
        ))}
        
        <ul className="arrow-ul">
          {data ? data?.map((policy) => {
            return <div dangerouslySetInnerHTML={{ __html: decodeHtml(policy?.remark ?? "") }} />
          }) : (
            <>
              <li>
                Cancellations made within the free cancellation period are
                eligible for a full refund. Late cancellations or no-shows may
                incur charges, including the full booking amount. Non-refundable
                bookings and promotional rates are not eligible for refunds.
              </li>
              <li>
                Non-Refundable Rate: No refunds for cancellations, no-shows, or
                early departures.
              </li>
              <li>
                Group Bookings: Special policies apply for group
                reservations—contact our team for details.
              </li>
            </>
          )}
        </ul>
      </div>
    </div>
  );
};

export const HotelCheckoutGeneralTerms = ({ data }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="hw-passenger--listShow__widget hw-hotel-checkout--terms">
      <div
        className="d-flex align-items-center justify-between hw-passenger--fareShowToggle"
        onClick={() => {
          setOpen(!open);
        }}
      >
        <span className="d-flex align-items-center hw-gapy10 hw-black hw-text18 hw-fontBold">
          <DocumentIcon />
          <div className="hw-black hw-text18 hw-fontBold">
            General Terms and Conditions
          </div>
        </span>

        {open ? <ChevronUpIcon /> : <ChevronDownIcon />}
      </div>

      
      {open ? (
        <ul className="arrow-ul">
          {data ? (
            <>
              {
                data?.map((room, roomIndex) => 
                  {room?.cancellationPolicy?.map((policy, policyIndex) => (
                    <div className="row mb-2" key={policyIndex}>
                      <div className="col-12">
                        <div className="hw-text14 hw-fontWeight--500"> From <strong>{policy.fromDate}</strong> 
                          to <strong>{policy.toDate}</strong>, a cancellation fee of <strong>AED {policy.amount}</strong> will apply.
                        </div>
                      </div>
                    </div>
                  ))}
                )
              }
              {
                data?.map((policy) => {
                  return <div dangerouslySetInnerHTML={{ __html: decodeHtml(policy?.remark ?? "") }} />
                })
              }
            </>
          ) : (
            <>
              <li>
                You should carry a print-out of your booking and present for
                check-in.
              </li>
              <li>
                Date & Time is calculated based on the local time of
                city/destination.
              </li>
              <li>Use the Reference Number for all Correspondence with us.</li>
              <li>
                Use the Airline PNR for all Correspondence directly with the
                Airline
              </li>
              <li>For departure terminal please check with airline first.</li>
              <li>
                Please CheckIn atleast 2 hours prior to the departure for
                domestic flight and 3 hours prior to the departure of
                international flight.
              </li>
              <li>
                For rescheduling/cancellation within 4 hours of departure time
                contact the airline directly
              </li>
            </>
          )}
        </ul>
      ) : null}
    </div>
  );
};
